<template>
  <v-list-item v-if="tree.id" dense class="pl-0">
    <search-list-avatar :type="tree.type" class="my-0" />
    <search-list-content :item="tree" :country-code="countryCode" link class="py-0" />
  </v-list-item>
  <span v-else-if="treeId && !hideId">{{ treeId }}</span>
</template>

<script>
import SearchListAvatar from '@/components/mv/SearchListAvatar.vue';
import SearchListContent from '@/components/mv/SearchListContent.vue';
import { getCountryByValue } from '@/helpers/filters';
import SEARCH from '@/api/owl-search.js';

export default {
  name: 'TreeItem',
  components: { SearchListContent, SearchListAvatar },
  props: {
    treeId: { type: Number, default: null },
    item: { type: Object, default: null },
    hideId: { type: Boolean, default: false },
    countryCode: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    tree: {},
  }),
  watch: {
    item(val) {
      this.tree = val;
    },
    treeId(val) {
      if (val) {
        this.fetchTree();
      }
    },
  },
  created() {
    if (this.item) {
      this.tree = this.item;
    } else if (this.treeId) {
      this.fetchTree();
    }
  },
  methods: {
    fetchTree() {
      let params = {
        id: this.treeId,
      };
      if (this.countryCode) params['country_code'] = getCountryByValue(this.countryCode);
      SEARCH.get('/tree/find', {
        params,
      }).then(({ data }) => {
        this.tree = data[0];
        if (this.tree && this.tree.country_codes && this.tree.country_codes.length > 0) {
          this.$emit('country-code-change', this.tree.country_codes[0]);
        }
      });
    },
  },
};
</script>
